/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MonitoringControllerDtoNftCarListNftCarData model module.
 * @module model/MonitoringControllerDtoNftCarListNftCarData
 * @version 1.0
 */
class MonitoringControllerDtoNftCarListNftCarData {
    /**
     * Constructs a new <code>MonitoringControllerDtoNftCarListNftCarData</code>.
     * @alias module:model/MonitoringControllerDtoNftCarListNftCarData
     */
    constructor() { 
        
        MonitoringControllerDtoNftCarListNftCarData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MonitoringControllerDtoNftCarListNftCarData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MonitoringControllerDtoNftCarListNftCarData} obj Optional instance to populate.
     * @return {module:model/MonitoringControllerDtoNftCarListNftCarData} The populated <code>MonitoringControllerDtoNftCarListNftCarData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MonitoringControllerDtoNftCarListNftCarData();

            if (data.hasOwnProperty('nftInventoryNo')) {
                obj['nftInventoryNo'] = ApiClient.convertToType(data['nftInventoryNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('minted')) {
                obj['minted'] = ApiClient.convertToType(data['minted'], 'Boolean');
            }
            if (data.hasOwnProperty('metadataUrl')) {
                obj['metadataUrl'] = ApiClient.convertToType(data['metadataUrl'], 'String');
            }
            if (data.hasOwnProperty('imageUrl')) {
                obj['imageUrl'] = ApiClient.convertToType(data['imageUrl'], 'String');
            }
            if (data.hasOwnProperty('vehicleType')) {
                obj['vehicleType'] = ApiClient.convertToType(data['vehicleType'], 'Number');
            }
            if (data.hasOwnProperty('vehicleGrade')) {
                obj['vehicleGrade'] = ApiClient.convertToType(data['vehicleGrade'], 'Number');
            }
            if (data.hasOwnProperty('plusFlag')) {
                obj['plusFlag'] = ApiClient.convertToType(data['plusFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('baseSpeed')) {
                obj['baseSpeed'] = ApiClient.convertToType(data['baseSpeed'], 'Number');
            }
            if (data.hasOwnProperty('baseLuck')) {
                obj['baseLuck'] = ApiClient.convertToType(data['baseLuck'], 'Number');
            }
            if (data.hasOwnProperty('baseEnergy')) {
                obj['baseEnergy'] = ApiClient.convertToType(data['baseEnergy'], 'Number');
            }
            if (data.hasOwnProperty('baseDurability')) {
                obj['baseDurability'] = ApiClient.convertToType(data['baseDurability'], 'Number');
            }
            if (data.hasOwnProperty('gemSocketColors')) {
                obj['gemSocketColors'] = ApiClient.convertToType(data['gemSocketColors'], 'String');
            }
            if (data.hasOwnProperty('gemSockets')) {
                obj['gemSockets'] = ApiClient.convertToType(data['gemSockets'], 'String');
            }
            if (data.hasOwnProperty('engineSocket')) {
                obj['engineSocket'] = ApiClient.convertToType(data['engineSocket'], 'Number');
            }
            if (data.hasOwnProperty('sigil')) {
                obj['sigil'] = ApiClient.convertToType(data['sigil'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('revealedAt')) {
                obj['revealedAt'] = ApiClient.convertToType(data['revealedAt'], 'Date');
            }
            if (data.hasOwnProperty('nftMintingNo')) {
                obj['nftMintingNo'] = ApiClient.convertToType(data['nftMintingNo'], 'Number');
            }
            if (data.hasOwnProperty('nftMergeNo')) {
                obj['nftMergeNo'] = ApiClient.convertToType(data['nftMergeNo'], 'Number');
            }
            if (data.hasOwnProperty('mintedAt')) {
                obj['mintedAt'] = ApiClient.convertToType(data['mintedAt'], 'Date');
            }
            if (data.hasOwnProperty('condition')) {
                obj['condition'] = ApiClient.convertToType(data['condition'], 'Number');
            }
            if (data.hasOwnProperty('distanceDriven')) {
                obj['distanceDriven'] = ApiClient.convertToType(data['distanceDriven'], 'Number');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('extraSpeed')) {
                obj['extraSpeed'] = ApiClient.convertToType(data['extraSpeed'], 'Number');
            }
            if (data.hasOwnProperty('extraLuck')) {
                obj['extraLuck'] = ApiClient.convertToType(data['extraLuck'], 'Number');
            }
            if (data.hasOwnProperty('extraEnergy')) {
                obj['extraEnergy'] = ApiClient.convertToType(data['extraEnergy'], 'Number');
            }
            if (data.hasOwnProperty('extraDurability')) {
                obj['extraDurability'] = ApiClient.convertToType(data['extraDurability'], 'Number');
            }
            if (data.hasOwnProperty('mintingCount')) {
                obj['mintingCount'] = ApiClient.convertToType(data['mintingCount'], 'Number');
            }
            if (data.hasOwnProperty('genesisMintingCount')) {
                obj['genesisMintingCount'] = ApiClient.convertToType(data['genesisMintingCount'], 'Number');
            }
            if (data.hasOwnProperty('valid')) {
                obj['valid'] = ApiClient.convertToType(data['valid'], 'Boolean');
            }
            if (data.hasOwnProperty('lastImportedAt')) {
                obj['lastImportedAt'] = ApiClient.convertToType(data['lastImportedAt'], 'Date');
            }
            if (data.hasOwnProperty('extraStatsPoint')) {
                obj['extraStatsPoint'] = ApiClient.convertToType(data['extraStatsPoint'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsSpeed')) {
                obj['extraStatsSpeed'] = ApiClient.convertToType(data['extraStatsSpeed'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsLuck')) {
                obj['extraStatsLuck'] = ApiClient.convertToType(data['extraStatsLuck'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsEnergy')) {
                obj['extraStatsEnergy'] = ApiClient.convertToType(data['extraStatsEnergy'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsDurability')) {
                obj['extraStatsDurability'] = ApiClient.convertToType(data['extraStatsDurability'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('storedPower')) {
                obj['storedPower'] = ApiClient.convertToType(data['storedPower'], 'Number');
            }
            if (data.hasOwnProperty('addedMaxStoredPower')) {
                obj['addedMaxStoredPower'] = ApiClient.convertToType(data['addedMaxStoredPower'], 'Number');
            }
            if (data.hasOwnProperty('addedMaxStoredPowerEndAt')) {
                obj['addedMaxStoredPowerEndAt'] = ApiClient.convertToType(data['addedMaxStoredPowerEndAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MonitoringControllerDtoNftCarListNftCarData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MonitoringControllerDtoNftCarListNftCarData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['metadataUrl'] && !(typeof data['metadataUrl'] === 'string' || data['metadataUrl'] instanceof String)) {
            throw new Error("Expected the field `metadataUrl` to be a primitive type in the JSON string but got " + data['metadataUrl']);
        }
        // ensure the json data is a string
        if (data['imageUrl'] && !(typeof data['imageUrl'] === 'string' || data['imageUrl'] instanceof String)) {
            throw new Error("Expected the field `imageUrl` to be a primitive type in the JSON string but got " + data['imageUrl']);
        }
        // ensure the json data is a string
        if (data['gemSocketColors'] && !(typeof data['gemSocketColors'] === 'string' || data['gemSocketColors'] instanceof String)) {
            throw new Error("Expected the field `gemSocketColors` to be a primitive type in the JSON string but got " + data['gemSocketColors']);
        }
        // ensure the json data is a string
        if (data['gemSockets'] && !(typeof data['gemSockets'] === 'string' || data['gemSockets'] instanceof String)) {
            throw new Error("Expected the field `gemSockets` to be a primitive type in the JSON string but got " + data['gemSockets']);
        }
        // ensure the json data is a string
        if (data['sigil'] && !(typeof data['sigil'] === 'string' || data['sigil'] instanceof String)) {
            throw new Error("Expected the field `sigil` to be a primitive type in the JSON string but got " + data['sigil']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} nftInventoryNo
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['nftInventoryNo'] = undefined;

/**
 * @member {Number} nftUid
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['nftUid'] = undefined;

/**
 * @member {Boolean} minted
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['minted'] = undefined;

/**
 * @member {String} metadataUrl
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['metadataUrl'] = undefined;

/**
 * @member {String} imageUrl
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['imageUrl'] = undefined;

/**
 * @member {Number} vehicleType
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['vehicleType'] = undefined;

/**
 * @member {Number} vehicleGrade
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['vehicleGrade'] = undefined;

/**
 * @member {Boolean} plusFlag
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['plusFlag'] = undefined;

/**
 * @member {Number} baseSpeed
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['baseSpeed'] = undefined;

/**
 * @member {Number} baseLuck
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['baseLuck'] = undefined;

/**
 * @member {Number} baseEnergy
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['baseEnergy'] = undefined;

/**
 * @member {Number} baseDurability
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['baseDurability'] = undefined;

/**
 * @member {String} gemSocketColors
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['gemSocketColors'] = undefined;

/**
 * @member {String} gemSockets
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['gemSockets'] = undefined;

/**
 * @member {Number} engineSocket
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['engineSocket'] = undefined;

/**
 * @member {String} sigil
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['sigil'] = undefined;

/**
 * @member {Date} createdAt
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['createdAt'] = undefined;

/**
 * @member {Date} revealedAt
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['revealedAt'] = undefined;

/**
 * @member {Number} nftMintingNo
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['nftMintingNo'] = undefined;

/**
 * @member {Number} nftMergeNo
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['nftMergeNo'] = undefined;

/**
 * @member {Date} mintedAt
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['mintedAt'] = undefined;

/**
 * @member {Number} condition
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['condition'] = undefined;

/**
 * @member {Number} distanceDriven
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['distanceDriven'] = undefined;

/**
 * @member {Number} level
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['level'] = undefined;

/**
 * @member {Number} extraSpeed
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['extraSpeed'] = undefined;

/**
 * @member {Number} extraLuck
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['extraLuck'] = undefined;

/**
 * @member {Number} extraEnergy
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['extraEnergy'] = undefined;

/**
 * @member {Number} extraDurability
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['extraDurability'] = undefined;

/**
 * @member {Number} mintingCount
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['mintingCount'] = undefined;

/**
 * @member {Number} genesisMintingCount
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['genesisMintingCount'] = undefined;

/**
 * @member {Boolean} valid
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['valid'] = undefined;

/**
 * @member {Date} lastImportedAt
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['lastImportedAt'] = undefined;

/**
 * @member {Number} extraStatsPoint
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['extraStatsPoint'] = undefined;

/**
 * @member {Number} extraStatsSpeed
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['extraStatsSpeed'] = undefined;

/**
 * @member {Number} extraStatsLuck
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['extraStatsLuck'] = undefined;

/**
 * @member {Number} extraStatsEnergy
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['extraStatsEnergy'] = undefined;

/**
 * @member {Number} extraStatsDurability
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['extraStatsDurability'] = undefined;

/**
 * @member {Number} accountNo
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['email'] = undefined;

/**
 * @member {Number} storedPower
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['storedPower'] = undefined;

/**
 * @member {Number} addedMaxStoredPower
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['addedMaxStoredPower'] = undefined;

/**
 * @member {Date} addedMaxStoredPowerEndAt
 */
MonitoringControllerDtoNftCarListNftCarData.prototype['addedMaxStoredPowerEndAt'] = undefined;






export default MonitoringControllerDtoNftCarListNftCarData;

